import CartComponent from '../../components/CartComponent'
import RootLayout from '../../layouts/Root/RootLayout'
import routes from './routes'

const PartnerLayout = (page) => <RootLayout CartComponent={CartComponent} page={page} routes={routes} />

export default PartnerLayout
